export { default } from './ProductPriceAvailability'
